import { ScrollScene } from 'scrollscene';

export const prefixEvent = (event, timing) => {
	const el = document.createElement('el');

	const prefixes = ['webkit', 'moz', 'MS', 'o', ''];
	let events = {};

	for(let prefix of prefixes) {
		events[prefix + event] = prefix + event + timing;
	}

	for(let e in events) {
		if(typeof el.style[e] !== undefined) {
			return events[e];
		}
	}
};

export const getCSSVariable = (variable, element = document.documentElement) => getComputedStyle(element).getPropertyValue(variable);

export const wait = (delay, value) => new Promise(resolve => setTimeout(resolve, delay, value));

export function escapeHTML(strings) {

	let result = strings[0];

	for(let i = 1; i < arguments.length; i++) {
		result += String(arguments[i]).replace(/[&<>'"]/g, (c) => {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
		});
		result += strings[i];
	}

	return result;
}

export function fixMobileHover() {

	if(!!('ontouchstart' in window) || !!('msmaxtouchpoints' in window.navigator)) {
		for(let sheetI = document.styleSheets.length - 1; sheetI >= 0; sheetI--) {
			let sheet = document.styleSheets[sheetI];
			if(sheet.cssRules) {
				for(let ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
					let rule = sheet.cssRules[ruleI];
					if(rule.selectorText) {
						rule.selectorText = rule.selectorText.replace(':hover', ':active');
					}
				}
			}
		}
	}
}

export const mediaQueryString = (breakpoint, min = true) => (min) ? `(min-width: ${breakpoint}px)` : `(max-width: ${breakpoint - 1}px)`;

export function mediaQuery(breakpoint, before, after) {

	const handler = (query) => {
		if(typeof after === 'function' && query.matches) {
			after();
		}
		else if(typeof before === 'function') {
			before();
		}
	};

	if(window.matchMedia) {
		const query = window.matchMedia(mediaQueryString(breakpoint));
		query.addListener(handler);
		handler(query);
	}
}

export function scrollPosition() {

	const root = document.documentElement;
	const body = document.body;

	const scrollTop = window.pageYOffset || root.scrollTop || body.scrollTop || 0;
	const scrollLeft = window.pageXOffset || root.scrollLeft || body.scrollLeft || 0;

	const clientTop = root.clientTop || body.clientTop || 0;
	const clientLeft = root.clientLeft || body.clientLeft || 0;

	return {
		scrollTop: scrollTop,
		scrollLeft: scrollLeft,
		clientTop: clientTop,
		clientLeft: clientLeft
	};
}

export function elementPosition(element) {

	const rect = element.getBoundingClientRect();

	const scroll = scrollPosition();

	return {
		top: Math.round(rect.top + scroll.scrollTop - scroll.clientTop),
		left: Math.round(rect.left + scroll.scrollLeft - scroll.clientLeft),
		height: rect.height,
		width: rect.width,
	};
}

export function replaceBodyClasses(next) {

	const parser = new DOMParser();
	const newPage = parser.parseFromString(next.html, "text/html");
	const newBody = newPage.querySelector('body');

	document.body.className = newBody.getAttribute('class');

	if(typeof gtag === 'function') {

		gtag('config', 'GTM-NTBV3ZL4', {
			'page_title': newPage.querySelector('head title').textContent,
			'page_path': window.location.pathname
		});
	}
}

export class DynamicScrollScene {

	constructor(params) {
		this.scene = null;
		this.params = params;
	}

	init() {
		this.scene = new ScrollScene(this.params());
	}

	refresh() {

		if(this.scene) {
			this.scene.destroy();
		}

		this.init();
	}
}

export function ajax(options = {}) {

	return new Promise((resolve, reject) => {

		jQuery.ajax(options).done(response => {

			if(response.success) {
				resolve(response);
			}
			else {
				console.error(response);
				reject(response);
			}
		}).fail(error => {
			console.error(error);
			reject(error);
		});
	});
}

(r => r.keys().map(r))(require.context('../../svg/', true, /\.svg$/));
(r => r.keys().map(r))(require.context('../../images/', true, /\.(gif|png|jpe?g|svg)$/));
